/**
 * Helpers for matching iOS / other-session evaluation clips onto a
 * (re)created training session.
 */

export function extractSessionListRows(response) {
  const body = response?.data;
  const rows =
    body?.group ||
    body?.data ||
    (Array.isArray(body) ? body : []) ||
    [];
  return Array.isArray(rows) ? rows : [];
}

export function sessionCalendarDayKey(value) {
  if (value == null || value === "") return null;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    return value.slice(0, 10);
  }
  if (typeof value === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
    const [dd, mm, yyyy] = value.split("/");
    return `${yyyy}-${mm}-${dd}`;
  }
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function sessionsEligibleForVideoImport(rows, currentTsId) {
  const current = currentTsId != null ? String(currentTsId) : "";
  const byId = new Map();
  for (const row of rows || []) {
    const tsId = row?.ts_id;
    if (tsId == null || String(tsId) === "" || String(tsId) === current) continue;
    const key = String(tsId);
    if (!byId.has(key)) byId.set(key, row);
  }
  return Array.from(byId.values());
}

export function clipExerciseUnmatched(clip, exercises) {
  const teId = clip?.te_id;
  if (teId == null || String(teId).trim() === "") return true;
  return !(exercises || []).some((ex) => String(ex?.te_id) === String(teId));
}
